import styled from 'styled-components';

export const Container = styled.div`
  align-items: start;
  display: grid;
  gap: 4.4rem;
  grid-template-columns: 42rem 1fr;
  height: 100%;
`;
